// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import CategoryItem from './Izenda.CategoryItem';
import LazyLoadingTreeView from 'share/components/controls/LazyLoadingTreeView/Izenda.LazyLoadingTreeView';
import { isNil, uniqueId, omit, find, invoke } from 'lodash/fp';

/**
 * CategoryTree component
 * Example :
 * <CategoryTree store={this.props.store} />
 */
@connect()
export default class CategoryTree extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    reportType: PropTypes.string,
    dataTree: PropTypes.object.isRequired,
    routeObject: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    selectedCategoryId: PropTypes.string,
    onLoadCategoryList: PropTypes.func,
    onValidateCategoryName: PropTypes.func,
    isLastPage: PropTypes.bool,
    registerLazyLoadingStore: PropTypes.func,
    getData: PropTypes.func.isRequired
  };

  getKey(node: any) {
    return isNil(node.source.id) ? uniqueId(node.source.name) : node.source.id;
  }

  shouldExpand(node: any) {
    return node.expand;
  }

  renderItem = (node: any, toggleIcon: any, toggle: any, isCollapsed: boolean, parent: any) => {
    const source = node.source,
      restProps = omit(['selectedCategoryId', 'dataTree'], this.props);

    return (
      <div>
        <CategoryItem
          dataSource={source}
          toggleIcon={toggleIcon}
          isGlobalLocal={isNil(parent)}
          getEditingCategoryTreeItem={this.getEditingCategoryTreeItem}
          {...restProps}
        />
      </div>
    );
  };

  /**
   * Get editing CategoryItem/SubCategoryItem (used for one-instance editing purpose)
   * @return {CategoryDetail} categoryDetail
   */
  getEditingCategoryTreeItem = () => {
    const { dataTree } = this.props;

    // find editing CategoryItem
    let editingCategoryTree = find('isEditing', dataTree);
    if (isNil(editingCategoryTree)) {
      // find editing SubCategoryItem
      dataTree.forEach(function(category) {
        var matched = find('isEditing', category.subCategories);
        if (matched) {
          editingCategoryTree = matched;
          return false;
        }
      });
    }

    return editingCategoryTree;
  };

  render() {
    const { store, dataTree, isLastPage, getData, registerLazyLoadingStore } = this.props;
    var getChildNodes = invoke('getChildNodes');

    return (
      <section className="category-tree u_fullHeight">
        <LazyLoadingTreeView
          className="u_paddingRight"
          nodes={dataTree}
          isLastPage={isLastPage}
          renderNode={this.renderItem}
          getKey={this.getKey}
          getChildNodes={getChildNodes}
          getData={getData}
          nodeExpand={this.shouldExpand}
          registerLazyLoadingStore={registerLazyLoadingStore}
        />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/CategoryTree/Izenda.CategoryTree.js